module.exports = __webpack_public_path__ + "img/Cabasa.0b1c3bdb.svg";